import { Flex } from 'foundations-components/components/Flex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import PlanBuilderContent from './PlanBuilderContent';
import { jsx as _jsx } from "react/jsx-runtime";
const PlanBuilderContainer = props => {
  const isAppReady = useGlobalLoading();
  if (isAppReady) {
    return /*#__PURE__*/_jsx(PlanBuilderContent, Object.assign({}, props));
  } else {
    return /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      inlineSize: "100%",
      minBlockSize: "600px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        "data-selenium-id": "plan-builder-loading-spinner",
        size: "medium"
      })
    });
  }
};
export default PlanBuilderContainer;